import axios, { type AxiosInstance } from 'axios';

const baseURLfromEnv: string = import.meta.env.ODJ_DEP_GATEWAY_ENDPOINT_BE_MAIN.includes('localhost')
  ? 'https://lidl-gateway-be-main.api.dev.sit.sys.odj.cloud/' //'http://127.0.0.1:8080/'
  : import.meta.env.ODJ_DEP_GATEWAY_ENDPOINT_BE_MAIN;
//const baseURLfromEnv: string = 'https://lidl-gateway-be-main.api.dev.sit.sys.odj.cloud/';

// console.log('baseURLfromEnv: ' + baseURLfromEnv);

const http: AxiosInstance = axios.create({
  baseURL: baseURLfromEnv,
  //  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(
  async (config) => {
    try {
      const accessToken = await waitForAccessToken();
      config.headers.Authorization = `Bearer ${accessToken}`;
    } catch (err) {
      // console.warn('Missing userData in sessionStorage. Cannot access token.');
    }

    if (config.url?.includes('gateway-schemes')) {
      config.baseURL = baseURLfromEnv;
      config.url = config.url.replace('/gateway-schemes', '');
    }
    if (config.url?.includes('gateway-settings')) {
      config.baseURL = baseURLfromEnv;
      config.url = config.url.replace('/gateway-settings', '');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default http;

function waitForAccessToken(timeout = 5000, interval = 100) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const check = () => {
      let accessToken = '';
      const userData = sessionStorage.getItem(
        `oidc.user:${import.meta.env.ODJ_DEP_GATEWAY_AUTH_IDP}:${import.meta.env.ODJ_DEP_GATEWAY_AUTH_CLIENT_ID}`
      );

      if (userData !== null) {
        accessToken = JSON.parse(userData).access_token;
      }

      if (accessToken) {
        resolve(accessToken);
      } else if (Date.now() - startTime >= timeout) {
        reject(new Error('Token not found in time.'));
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
}
